// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shop-5"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.7432 5.23047C20.9131 5.74027 21.0349 6.28384 20.8916 6.80176C20.7557 7.29287 20.4982 7.73344 20.1533 8.08887L20 8.23633V21H4V8.23633L3.8877 8.12988C3.33963 7.58631 3 6.8329 3 6L4 3H20L20.7432 5.23047Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 14H9V21H15V14Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M15 14H9V21H15V14Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6C15 7.65685 16.3431 9 18 9M15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6M15 6V3M18 9C18.6723 9 19.2928 8.77875 19.793 8.40527L20 8.23633M18 9C18.7684 9 19.4692 8.71137 20 8.23633M20 8.23633V21M20 8.23633C20.422 7.85866 20.7364 7.3631 20.8917 6.80167C21.035 6.28371 20.9134 5.74008 20.7434 5.23025L20 3H15M20 21H4M20 21H21M4 21V8.23633M4 21H3M4 8.23633C4.53074 8.71131 5.2317 9 6 9C7.65685 9 9 7.65685 9 6M4 8.23633C3.38625 7.68701 3 6.8885 3 6L4 3H9M9 6V3M9 3H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Shop5Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-5',
    ref,
    icon: element,
  },
));

Shop5Icon.displayName = 'Shop5Icon';

export default Shop5Icon;
